import { Card } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { DATE_FORMATS, ROUTES } from '../../../common/constants';
import { formatDate } from '../../../common/utils';

const RackMasterCard = ({ order, infiniteScrollRef }) => {
  const history = useHistory();

  return (
    <div>
      {' '}
      <Card
        className="rack-master-card ml-12 mr-12 mb-24 mt-12 mobile-card"
        title={
          <div className="overflow-scroll no-scroll-bar">{order?.name}</div>
        }
        ref={infiniteScrollRef}
        onClick={() => {
          history?.push(`${ROUTES?.RACK_MASTER}/view/${order?.id}`);
        }}
      >
        <div>
          <div className="mb-8">
            <span className="mobile-card-label">Shelf Name: </span>
            <span>{order?.name || 'No Shelf Name'}</span>
          </div>
          <div className="mb-8">
            <span className="mobile-card-label">Created At: </span>
            <span>
              {formatDate(order?.createdAt, DATE_FORMATS?.REGULAR) || '-'}
            </span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RackMasterCard;
